import { ReactNode } from "react";

/**
 * Centered desktop "phone card" frame: a grey gutter (#f0f1f3) with a white
 * 600px column and a soft shadow — the same treatment Flight School, lessons,
 * and the course/chapter detail screens use, so standalone full-screen pages
 * (auth, onboarding, etc.) read as one consistent centered phone on wide
 * viewports. On a phone the column is full-width, so the gutter never shows and
 * nothing changes.
 *
 * NB: deliberately no `transform` here — a transform would make the card the
 * containing block for `position: fixed` descendants, and since the card
 * scrolls that turns fixed footers/FABs into scrolling elements. Pages already
 * self-center their fixed elements (e.g. left:0/right:0 + max-w-600), so plain
 * viewport-fixed positioning is correct.
 *
 * `white`: the start screens (`/`, `/login`, `/signup`) opt out of the gray
 * gutter and read as plain white on wide viewports (locked product decision) —
 * white gutter + white column + no card shadow, so the sides are seamless.
 */
export function PhoneCard({
  children,
  white = false,
}: {
  children: ReactNode;
  white?: boolean;
}) {
  return (
    <div
      style={{
        height: "100dvh",
        overflow: "hidden",
        background: white ? "#ffffff" : "#f0f1f3",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          maxWidth: 600,
          height: "100%",
          overflowY: "auto",
          background: white ? "#ffffff" : "#fafafa",
          boxShadow: white ? "none" : "0 0 50px rgba(0,0,0,0.07)",
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default PhoneCard;
